import { render, staticRenderFns } from "./fakeTransactionsDetail.vue?vue&type=template&id=6602a3c7&scoped=true&"
import script from "./fakeTransactionsDetail.vue?vue&type=script&lang=js&"
export * from "./fakeTransactionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./fakeTransactionsDetail.vue?vue&type=style&index=0&id=6602a3c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602a3c7",
  null
  
)

export default component.exports